import axios from 'axios';
export const listProofLocationByRange = async (proofsProxiesApiRoot, auth, range) => axios
    .get(`${proofsProxiesApiRoot}/proofLocation?from=${range.from}&to=${range.to}`, {
    headers: {
        Authorization: auth.value(),
    },
})
    .then((output) => output.data);
export const storePokProof = async (proofsProxiesApiRoot, auth, input) => {
    return axios.post(`${proofsProxiesApiRoot}/pokProof/${input.wallet}`, { id: input.id, proof: input.proof }, {
        headers: {
            Authorization: auth.value(),
        },
    });
};
export const getProofLocation = async (proofsProxiesApiRoot, id) => axios
    .get(`${proofsProxiesApiRoot}/proofLocation/${id}`)
    .then((response) => {
    return response.data;
})
    .catch(async (e) => {
    if (e.response?.status === 404) {
        return undefined;
    }
    throw e;
});
//# sourceMappingURL=index.js.map